import { c as _c } from "react/compiler-runtime";
import { classNames } from "../../../utils";
import { EmptyState } from "../../EmptyState";
import { TimeSeriesChartSkeleton } from "./TimeSeriesChartSkeleton";
export function TimeSeriesChartEmptyState(t0) {
  const $ = _c(8);
  const {
    overrides,
    className
  } = t0;
  const t1 = overrides?.Skeleton?.className;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = classNames(className, t1);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = overrides?.EmptyState;
  let t4;
  if ($[3] !== t3) {
    t4 = <EmptyState showIcon={false} variant="no-chart-data" {...t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <TimeSeriesChartSkeleton className={t2}>{t4}</TimeSeriesChartSkeleton>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}